import React, { useEffect, useState } from 'react';
import { Snackbar, Alert } from '@mui/material';
import { useTranslation } from 'react-i18next';

export const PWAUpdateNotification: React.FC = () => {
  const [showUpdateNotification, setShowUpdateNotification] = useState(false);
  const { t } = useTranslation();

  useEffect(() => {
    // Détecter quand un nouveau service worker prend le contrôle
    if ('serviceWorker' in navigator) {
      const handleControllerChange = () => {
        console.log('Nouveau service worker activé');
        setShowUpdateNotification(true);

        // Fermer automatiquement après 3 secondes
        setTimeout(() => {
          setShowUpdateNotification(false);
        }, 3000);
      };

      navigator.serviceWorker.addEventListener('controllerchange', handleControllerChange);

      return () => {
        navigator.serviceWorker.removeEventListener('controllerchange', handleControllerChange);
      };
    }
  }, []);

  const handleClose = () => {
    setShowUpdateNotification(false);
  };

  return (
    <Snackbar
      open={showUpdateNotification}
      autoHideDuration={3000}
      onClose={handleClose}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
    >
      <Alert severity="success" onClose={handleClose}>
        {t('common.appUpdated', 'Application mise à jour avec succès')}
      </Alert>
    </Snackbar>
  );
};
